import { type FC } from 'react'
import classNames from 'classnames'
import { FormHint } from './FormHint'

interface GroupHeadingProps {
  title?: string
  description?: string
  className?: string
  titleClassName?: string
  titleAs?: 'div' | 'h6'
}

export const GroupHeading: FC<GroupHeadingProps> = ({ title, description, className, titleClassName = 'paragraph-small bold', titleAs: Title = 'div' }) =>
  title || description ? (
    <div className={classNames('d-flex flex-column', className)}>
      {title ? <Title className={classNames(titleClassName, { 'mb-0': Title !== 'div' })}>{title}</Title> : null}
      {description
        ? description.split('\n').map((paragraph, index) => (
            <FormHint key={index} className={classNames({ 'mt-1': index > 0 })}>
              {paragraph}
            </FormHint>
          ))
        : null}
    </div>
  ) : null
